import * as React from 'react';
import type { SVGProps } from 'react';

const IconClose = React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
  <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 23 23" {...props}>
    <path
      stroke="currentColor"
      strokeWidth="currentStroke"
      d="M1.448 21.293 21.346 1.395M21.191 21.605 1.293 1.707"
    />
  </svg>
));
IconClose.displayName = 'IconClose';
export default IconClose;
